var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 259,
    viewBox: "0 0 414 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336.9 22.3H77.1002C54.0002 22.3 35.2002 41 35.2002 64.1V194.1C35.2002 217.2 54.0002 235.9 77.1002 235.9H336.9C360 235.9 378.8 217.2 378.8 194.1V64.1C378.8 41 360 22.3 336.9 22.3Z",
    fill: "#5CBDC5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.8 211.5C221.376 211.5 256.7 176.175 256.7 132.6C256.7 89.0247 221.376 53.7 177.8 53.7C134.225 53.7 98.9004 89.0247 98.9004 132.6C98.9004 176.175 134.225 211.5 177.8 211.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.8 203.7C217.068 203.7 248.9 171.867 248.9 132.6C248.9 93.3326 217.068 61.5 177.8 61.5C138.533 61.5 106.7 93.3326 106.7 132.6C106.7 171.867 138.533 203.7 177.8 203.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.6 122H176C175 122 174.2 121.2 174.2 120.2V83.8C174.2 82.8 175 82 176 82H178.6C179.6 82 180.4 82.8 180.4 83.8V120.2C180.4 121.2 179.6 122 178.6 122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.501 165.5L147.601 163.8C146.901 163.1 146.801 162 147.401 161.3L172.701 132.7C173.401 132 174.501 131.9 175.201 132.5L177.101 134.2C177.801 134.9 177.901 136 177.301 136.7L152.001 165.3C151.401 166.1 150.301 166.1 149.501 165.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.1 70.3H176.3C175.6 70.3 175 69.7 175 69V64.8C175 64.1 175.6 63.5 176.3 63.5H178.1C178.8 63.5 179.4 64.1 179.4 64.8V69C179.4 69.8 178.8 70.3 178.1 70.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.1 201.6H176.3C175.6 201.6 175 201 175 200.3V196.1C175 195.4 175.6 194.8 176.3 194.8H178.1C178.8 194.8 179.4 195.4 179.4 196.1V200.3C179.4 201 178.8 201.6 178.1 201.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.5 131.7V133.5C115.5 134.2 114.9 134.8 114.2 134.8H110C109.3 134.8 108.7 134.2 108.7 133.5V131.7C108.7 131 109.3 130.4 110 130.4H114.2C114.9 130.4 115.5 131 115.5 131.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.2 131.7V133.5C247.2 134.2 246.6 134.8 245.9 134.8H241.7C241 134.8 240.4 134.2 240.4 133.5V131.7C240.4 131 241 130.4 241.7 130.4H245.9C246.7 130.4 247.2 131 247.2 131.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.6 172.6L183.7 139.7C183.3 139.3 183.4 138.7 183.8 138.3L184.8 137.4C185.2 137 185.8 137.1 186.2 137.5L216.1 170.4C216.5 170.8 216.4 171.4 216 171.8L215 172.7C214.6 173.1 214 173 213.6 172.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.3 144.6C184.149 144.6 189.7 139.048 189.7 132.2C189.7 125.352 184.149 119.8 177.3 119.8C170.452 119.8 164.9 125.352 164.9 132.2C164.9 139.048 170.452 144.6 177.3 144.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.3 140.6C181.94 140.6 185.7 136.839 185.7 132.2C185.7 127.561 181.94 123.8 177.3 123.8C172.661 123.8 168.9 127.561 168.9 132.2C168.9 136.839 172.661 140.6 177.3 140.6Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.4 208.8C233.804 208.8 269.8 172.804 269.8 128.4C269.8 83.9963 233.804 48 189.4 48C144.996 48 109 83.9963 109 128.4C109 172.804 144.996 208.8 189.4 208.8Z",
    fill: "#25A3DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.4 200.8C229.385 200.8 261.8 168.385 261.8 128.4C261.8 88.4146 229.385 56 189.4 56C149.415 56 117 88.4146 117 128.4C117 168.385 149.415 200.8 189.4 200.8Z",
    fill: "#ECEFF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.2 117.6H187.5C186.5 117.6 185.7 116.8 185.7 115.8V78.6C185.7 77.6 186.5 76.8 187.5 76.8H190.2C191.2 76.8 192 77.6 192 78.6V115.8C192 116.8 191.2 117.6 190.2 117.6Z",
    fill: "#5E717A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.6 161.9L158.6 160.1C157.9 159.4 157.8 158.3 158.4 157.6L184.2 128.4C184.9 127.7 186 127.6 186.7 128.2L188.7 130C189.4 130.7 189.5 131.8 188.9 132.5L163.1 161.7C162.5 162.5 161.4 162.5 160.6 161.9Z",
    fill: "#5E717A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M189.7 64.9H187.8C187.1 64.9 186.5 64.3 186.5 63.6V59.3C186.5 58.6 187.1 58 187.8 58H189.7C190.4 58 191 58.6 191 59.3V63.6C191 64.4 190.4 64.9 189.7 64.9Z",
    fill: "#5E717A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.7 198.6H187.8C187.1 198.6 186.5 198 186.5 197.3V193C186.5 192.3 187.1 191.7 187.8 191.7H189.7C190.4 191.7 191 192.3 191 193V197.3C191 198.1 190.4 198.6 189.7 198.6Z",
    fill: "#5E717A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.9 127.4V129.3C125.9 130 125.3 130.6 124.6 130.6H120.3C119.6 130.6 119 130 119 129.3V127.4C119 126.7 119.6 126.1 120.3 126.1H124.6C125.4 126.2 125.9 126.7 125.9 127.4Z",
    fill: "#5E717A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M260.1 127.4V129.3C260.1 130 259.5 130.6 258.8 130.6H254.5C253.8 130.6 253.2 130 253.2 129.3V127.4C253.2 126.7 253.8 126.1 254.5 126.1H258.8C259.6 126.2 260.1 126.7 260.1 127.4Z",
    fill: "#5E717A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M225.9 169.1L195.4 135.5C195 135.1 195.1 134.5 195.5 134.1L196.6 133.1C197 132.7 197.6 132.8 198 133.2L228.5 166.8C228.9 167.2 228.8 167.8 228.4 168.2L227.3 169.2C226.8 169.6 226.2 169.5 225.9 169.1Z",
    fill: "#E1685A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M188.9 140.7C195.914 140.7 201.6 135.014 201.6 128C201.6 120.986 195.914 115.3 188.9 115.3C181.886 115.3 176.2 120.986 176.2 128C176.2 135.014 181.886 140.7 188.9 140.7Z",
    fill: "#EDBF53"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.9 136.6C193.649 136.6 197.5 132.75 197.5 128C197.5 123.25 193.649 119.4 188.9 119.4C184.15 119.4 180.3 123.25 180.3 128C180.3 132.75 184.15 136.6 188.9 136.6Z",
    fill: "#F4CD7D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M250.4 149.2L222.4 194C213.5 208 221.9 211.8 231.4 210.8H291.2C304.2 210.9 309.9 206.2 300.1 192.7L272.3 149.1C265.2 140.5 257.8 140.9 250.4 149.2Z",
    fill: "#FFC301"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M256 158.1L258 189.6H265.8L267.6 158.1H256Z",
    fill: "#E94A66"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M261.801 205.3C265.114 205.3 267.801 202.614 267.801 199.3C267.801 195.986 265.114 193.3 261.801 193.3C258.487 193.3 255.801 195.986 255.801 199.3C255.801 202.614 258.487 205.3 261.801 205.3Z",
    fill: "#E94A66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.1fb897c9735293b513417b652885e56b.svg";
export { ForwardRef as ReactComponent };